
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Redirect www to the main domain
if (window.location.hostname === 'www.singaraa.in') {
  window.location.replace(
    'https://singaraa.in' +
    window.location.pathname +
    window.location.search +
    window.location.hash
  );
} else {
  // Initialize Meta Pixel
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script',
    'https://connect.facebook.net/en_US/fbevents.js'
  );

  window.fbq('init', '1586085196625233');
  window.fbq('track', 'PageView');

  const root = ReactDOM.createRoot(
    document.getElementById('root')
  );

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  reportWebVitals();
}
